module.exports = __webpack_public_path__ + "img/app1.e3e451fb.png";